// src/contexts/ColorThemeContext.js
import PropTypes from "prop-types";
import React, { createContext, useContext, useState, useEffect } from "react";

const DEFAULT_COLORS = {
  dashboardBackground: "#ffffff",
  dashboardText: "#000000",
  popupBackground: "#f0f0f0",
  popupText: "#333333",
  sideBackground: "#eeeeee",
  sideText: "#111111",
};

const ColorThemeContext = createContext(DEFAULT_COLORS);

export const useColorTheme = () => useContext(ColorThemeContext);

export function ColorThemeProvider({ children }) {
  const [colors, setColors] = useState(DEFAULT_COLORS);

  useEffect(() => {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        if (user.colors) {
          setColors((prev) => ({ ...prev, ...user.colors }));
        }
      }
    } catch (error) {
      console.error("Lỗi khi đọc màu từ localStorage:", error);
    }
  }, []);

  return <ColorThemeContext.Provider value={colors}>{children}</ColorThemeContext.Provider>;
}

ColorThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
